import * as React from "react";

const LocationPinIconSVG = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20">
        <path
            fill="#7C3AED"
            d="M8 10q.824 0 1.413-.587Q10 8.825 10 8q0-.824-.587-1.412A1.93 1.93 0 0 0 8 6q-.824 0-1.412.588A1.93 1.93 0 0 0 6 8q0 .824.588 1.413Q7.175 10 8 10m0 7.35q3.05-2.8 4.525-5.088Q14 9.976 14 8.2q0-2.725-1.738-4.462Q10.526 2 8 2T3.738 3.737Q2 5.476 2 8.2q0 1.775 1.475 4.063Q4.95 14.548 8 17.35M8 20q-4.024-3.425-6.012-6.363Q0 10.7 0 8.2q0-3.75 2.412-5.975T8 0t5.588 2.225T16 8.2q0 2.5-1.988 5.438T8 20"
        ></path>
    </svg>
);

export default LocationPinIconSVG;
